import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$workspaceSlug/settings/profile",
      params: { workspaceSlug: params.workspaceSlug },
    });
  },
});
